<template>
  <div>
    <!-- 第一屏 -->
    <div class="container-1">
      <div @click="goGenerate()" class="pink-button button-1">
          <span>创作我的二维码</span>      
      </div>
      <img class="cafeimage" src="../assets/img/images/13.png" alt="背景图片"/>
    </div>
    <div class="container-2">
      <p class="slogan">
        4步创建二维码
      </p>
      <div class="sign-container-box">
        <div class="sign-container">
          <img class="image-1" src="../assets/img/images/2(5)-180x180-1.png" alt="使用美钥二维码">
          <img class="image-2" src="../assets/img/images/5(2)-40x40.png" alt="1号编号">
          <p class="text">输入自定义内容</p> 
        </div>
        <div class="sign-container">
          <img class="image-1" src="../assets/img/images/1(5)-230x230.png" alt="使用美钥二维码">
          <img class="image-2" src="../assets/img/images/6-40x40.png" alt="2号编号">
          <p class="text">上传自定义图片</p>
        </div>
        <div class="sign-container">
          <img class="image-1" src="../assets/img/images/3(3)-180x179-1.png" alt="使用美钥二维码">
          <img class="image-2" src="../assets/img/images/7-40x40.png" alt="3号编号">
          <p class="text">轻点制作</p>
        </div>
        <div class="sign-container">
          <img class="image-1" src="../assets/img/images/4(2)-192x192-2.png" alt="使用美钥二维码">
          <img class="image-2" src="../assets/img/images/8-40x40.png" alt="4号编号">
          <p class="text">得到美钥码</p>
        </div>
      </div>
      <div @click="goGenerate()" class="pink-button button-2">
        <span>已经学会，马上制作</span>
      </div>
    </div>

    <div class="container-3">
       <p class="slogan">
         告别黑白，我们的世界应该绚丽多彩！
      </p>
      <div class="sample-compare-box">
         <img src="../assets/img/images/2(6)-340x379.png" alt="传统二维码">
         <img src="../assets/img/images/3(4)-340x378.jpg" alt="美钥二维码">
      </div>
      <div @click="goRegister()" class="white-button button-3">
          <span>马上加入，点击注册</span>
      </div>
    </div>

    <div class="container-4">
      <p class="slogan">便捷的管理，扫码数据分析系统</p>
      <div class="manage-box">
        <div class="sign-container">
          <img class="image-1" src="../assets/img/images/new image - meak1.jpg" alt="美钥二维码统计图">
          <div class="sign">
             <i class="fa fa-caret-right pink-text" aria-hidden="true"></i>
             <span class="text">可以为用户提供专业的数据管理能力，分析并预测扫码数据分布。专业的数据分析，跟踪记录数据信息。</span>
          </div>
        </div>
        <div class="sign-container">
          <img class="image-2" src="../assets/img/images/new image - gllxe.jpg" alt="美钥二维码统计图">
          <div class="sign">
             <i class="fa fa-caret-right pink-text" aria-hidden="true"></i>
             <span class="text">平台提供数据监测能力，记录信息。</span>
          </div>
        </div>
      </div>
      <div @click="goLogin()" class="pink-button button-4">
          <span>管理我的二维码</span>
      </div>
    </div>
    <div class="container-5">
      <div class="part-1">
        <div class="merit-box">
          <div class="merit">
            <img class="image" src="../assets/img/images/new image - kncyu.jpg" alt="心">
            <p class="text-1">个性美观</p>
            <p class="text-2">可在相同信息条件下呈现更多视觉有意义信息，帮助商户树立品牌价值，自动生成卡通画效果，满足用户个性化需求</p>
          </div>
          <div class="merit">
            <img class="image" src="../assets/img/images/new image - nvd53.jpg" alt="时间">
            <p class="text-1">制作简单</p>
            <p class="text-2">节省时间，制作步骤轻松易懂。只需四个步骤，即可轻松学会，制作属于自己的二维码</p>
          </div>
          <div class="merit">
            <img class="image" src="../assets/img/images/new image - yk6jg.jpg" alt="美钥二维码统计图">
            <p class="text-1">管理分析</p>
            <p class="text-2">平台提供数据监测能力和专业数据分析，跟踪记录数据信息。可以为用户提供专业的数据管理能力，分析并预测扫码数据分布</p>
          </div>
        </div>
        <div @click="goRegister()" class="white-button button-5">
          <span>马上加入，点击注册</span>
        </div>
      </div>
      <div class="part-2">
        <p class="text">合作伙伴</p>
        <div class="partner-list">
          <a href="https://baike.baidu.com/item/中原大地传媒股份有限公司/2913341" target="_blank">
            <img src="../assets/img/images/partner1.jpg" alt="合作伙伴"/>
          </a>
          <a href="http://www.11467.com/zhengzhou/co/29016.htm" target="_blank">
            <img src="../assets/img/images/partner2.jpg" alt="合作伙伴"/>
          </a>
          <a href="http://www.daxiang.cn" target="_blank">
            <img src="../assets/img/images/partner3.jpg" alt="合作伙伴"/>
          </a>
          <a href="http://www.haiyan.com/portal.php" target="_blank">
            <img src="../assets/img/images/partner4.jpg" alt="合作伙伴"/>
          </a>
          <a href="http://www.hnaskj.com/" target="_blank">
            <img src="../assets/img/images/partner5.jpg" alt="合作伙伴"/>
          </a>
        </div>
      </div>
    </div>
    <frontFooter></frontFooter>
  </div>
</template>

<script>
import frontFooter from '@c/navigation/frontFooter.vue'
export default {
  name: 'homepage',
  components: {
    frontFooter
  },
  mounted () {
    document.title = '美钥二维码 一站式二维码生成美化管理平台'
  },
  methods: {
    goRegister () {
      this.$router.push('/user/register')
    },
    goGenerate () {
      this.$router.push('/qrgenerate/url')
    },
    goLogin () {
      this.$router.push('/user/login')
    }
  }
}

</script>


<style type="text/css" scoped>
.container-1,
.container-2,
.container-3,
.container-4,
.container-5 {
  padding-bottom: 50px;
}
.container-1 {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: url('../assets/img/images/38.jpg');
  height: 900px;
  margin-top: 60px;
  border-top: solid 1px rgba(0, 0, 0, 0);
  position: relative;
}
.container-2 {
  height: 900px;
  border-top: solid 1px rgba(0, 0, 0, 0);
}
.container-3 {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  background-image: url('../assets/img/images/54.jpg');
  height: 900px;
  border-top: solid 1px rgba(0, 0, 0, 0);
}
.container-4 {
  height: 900px;
  border-top: solid 1px rgba(0, 0, 0, 0);
}
.container-5 {
  height: 900px;
}

.pink-button {
  cursor: pointer;
  width: 450px;
  height: 75px;
  box-shadow: 2px 2px 2px rgba(1,1,1, 0.1);
  border-radius: 51px;
  background-color: #fe816d;
  display: table;
}

.white-button {
  cursor: pointer;
  width: 450px;
  height: 75px;
  box-shadow: 2px 2px 2px rgba(1,1,1, 0.1);
  border-radius: 51px;
  background-color: white;
  display: table;
}

.pink-button span {
  display: table-cell;
  font-size: 30px;
  color: white;
  text-align: center;
  vertical-align: middle;
}

.white-button span {
  display: table-cell;
  font-size: 30px;
  color: #fe816d;
  text-align: center;
  vertical-align: middle;
}

.button-1 {
  margin: 170px auto 0;
}

.button-2 {
  margin: 70px auto 0;
}

.button-3 {
  margin: 80px auto 0;
}

.button-4 {
  margin: 50px auto 0;
}

.button-5 {
  margin: 50px auto 0;
}

.cafeimage {
  position: absolute;
  height: 600px;
  bottom: 0;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
}

.container-2 .slogan {
  color: rgb(254, 129, 109);
  margin: 100px auto 0;
  text-align: center;
  font-size: 30px;
}

.container-3 .slogan {
  color: white;
  margin: 100px auto 0;
  text-align: center;
  font-size: 30px;
}

.container-4 .slogan {
  color: black;
  margin: 80px auto 0;
  text-align: center;
  font-size: 30px;
}

.sign-container-box {
  display: -webkit-flex; /* Safari */
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
  margin-top: 50px;
  margin-left: 50px;
  margin-right: 50px;
}

.sign-container-box .sign-container {
  width: 300px;
  text-align: center;
}

.sign-container-box .sign-container .image-1 {
  max-width: 100%;
}

.sign-container-box .sign-container .image-2 {
  margin-top: 30px;
}

.sign-container-box .sign-container .text {
  margin-top: 30px;
  font-size: 25px;
  color: #555555;
}

.sample-compare-box {
  display: -webkit-flex; /* Safari */
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 80px;
}

.sample-compare-box img {
  margin-left: 70px;
  margin-right: 70px;
}

.manage-box{
  display: -webkit-flex; /* Safari */
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  margin-top: 40px;
}

.manage-box .sign-container {
  width: 500px;
  margin-left: 70px;
  margin-right: 70px;
}

.manage-box .sign-container:last-child {
  width: 250px;
}

.manage-box .image-1 {
  width: 500px;
}

.manage-box .image-2 {
  width: 250px;
}

.manage-box .sign-container .sign {
  margin-top: 20px;
  width: 500px;
}

.pink-text {
  color: rgb(254, 129, 109);
  font-size: 24px;
}

.manage-box .text {
  font-size: 18px;
}

.container-5 .part-1 {
  height: 550px;
  border-top: solid 1px rgba(0, 0, 0, 0);
  background-image: url('../assets/img/images/54.jpg');
}

.merit-box {
  display: -webkit-flex; /* Safari */
  display: flex;
  justify-content: space-around;
  flex-wrap: nowrap;
  margin-top:  80px;
}

.merit {
  width: 320px;
  text-align: center;
}

.merit .image{
  width: 100px;
  margin-left: auto;
  margin-right: auto;
}

.merit .text-1 {
  font-size: 30px;
  color: white;
}

.merit .text-2 {
  text-align: justify;
  text-justify: inter-ideograph;/*IE*/
  color: white;
  font-size: 16px;
}

.part-2 {
  text-align: center;
}

.part-2 .text {
  font-size: 30px;
  margin: 40px auto 0;
}

.part-2 .partner-list {
  width: 900px;
  height: 150px;
  border: #cccccc solid 1px;
  margin: 40px auto 0;
  background: white;
}
.partner-list img {
  margin: 5px 10px;
  height: 140px;
  border-radius: 5px;
  opacity: 0.7;
  filter:alpha(opacity=70); /* 针对 IE8 以及更早的版本 */
  cursor: pointer;
}
.partner-list img:hover {
  opacity: 0.95;
  filter:alpha(opacity=95); /* 针对 IE8 以及更早的版本 */
}

@media(max-width: 1915px) {
  .container-1 {
    height: 650px;
    margin-top: 60px;
  }
  .container-2 {
    margin: 30px auto 0;
    height: 650px;
  }
  .container-3 {
    height: 650px;
  }
  .container-4 {
    height: 650px;
  }
  .container-5 {
    height: 650px;
  }
  .pink-button {
    width:  400px;
    height: 70px;
    border-radius: 51px;
  }

  .white-button {
    width:  400px;
    height: 70px;
    border-radius: 51px;
  }

  .pink-button span {
    font-size: 26px;
  }

  .white-button span {
    font-size: 26px;
  }

  .cafeimage {
    height: 450px;
    z-index: 0;
  }

  .container-2 .slogan {
    font-size: 26px;
    margin: 60px auto 0;
  }

  .container-3 .slogan {
    font-size: 26px;
    margin-top: 80px;
  }

  .container-4 .slogan {
    font-size: 26px;
    margin-top: 70px;  
  }

  .button-1 {
    margin: 120px auto 0;
  }

  .button-2 {
    margin: 70px auto 0;
  }

  .button-3 {
    margin: 70px auto 0;
  }

  .button-4 {
    margin: 50px auto 0;
  }

  .button-5 {
    margin: 30px auto 0;
  }

  .sign-container-box {
    margin-top: 80px;
    margin-left: 30px;
    margin-right: 30px;
  }

  .sign-container-box .sign-container {
    width: 160px;
    text-align: center;
    margin-bottom: 10px;
  }

  .sign-container-box .sign-container .image-1 {
    max-width: 100%;
  }

  .sign-container-box .sign-container .image-2 {
    margin-top: 10px;
    max-width: 25px;
  }

  .sign-container-box .sign-container .text {
    margin-top: 10px;
    font-size: 18px;
  }
  .sample-compare-box {
    flex-wrap: nowrap;
    margin-top: 50px;
  }

  .sample-compare-box img {
    margin: 40px;
    width: 260px;
    height: 260px;
  }

  .manage-box{
    margin-top: 30px;
  }

  .manage-box .sign-container {
    width: 300px;
    margin: 30px 30px 0;
  }

  .manage-box .sign-container:last-child {
    width: 150px;
  }

  .manage-box .image-1 {
    width: 300px;
  }

  .manage-box .image-2 {
    width: 150px;
  }

  .manage-box .sign-container .sign {
    margin-top: 20px;
    width: 100%;
  }

  .manage-box .text {
    font-size: 12px;
    text-align: justify;
    text-justify: inter-ideograph;/*IE*/
  }

  .merit-box {
    margin-top:  40px;
  }

  .merit {
    width: 160px;
  }

  .merit .image{
    width: 60px;
  }

  .merit .text-1 {
    font-size: 18px;
  }

  .merit .text-2 {
    font-size: 14px;
  }
  
  .container-5 .part-1 {
    height: 400px;
   }

  .part-2 .text {
    font-size: 22px;
  }

  .part-2 .partner-list {
    width: 600px;
    height: 100px;
  }
  .partner-list img {
    margin: 5px 10px;
    height: 90px;
  }
}
@media(max-width: 991px) {
  .container-1 {
    height: 700px;
    margin-top: 60px;
  }
  .container-2 {
    margin: 30px auto 0;
    height: 700px;
  }
  .container-3 {
    height: 700px;
  }
  .container-4 {
    height: 700px;
  }
  .container-5 {
    height: 700px;
  }
  .pink-button {
    width: 400px;
    height: 70px;
    border-radius: 51px;
  }

  .white-button {
    width: 400px;
    height: 70px;
    border-radius: 51px;
  }

  .pink-button span {
    font-size: 26px;
  }

  .white-button span {
    font-size: 26px;
  }

  .cafeimage {
    height: 420px;
  }

  .container-2 .slogan {
    font-size: 26px;
    margin: 70px auto 0;
  }

  .container-3 .slogan {
    font-size: 26px;
    margin-top: 70px;
  }

  .container-4 .slogan {
    font-size: 26px;
    margin-top: 70px;  
  }

  .button-1 {
    margin: 170px auto 0;
  }

  .button-2 {
    margin: 70px auto 0;
  }

  .button-3 {
    margin: 70px auto 0;
  }

  .button-4 {
    margin: 50px auto 0;
  }

  .button-5 {
    margin: 30px auto 0;
  }

  .sign-container-box {
    margin-top: 70px;
    margin-left: 30px;
    margin-right: 30px;
  }

  .sign-container-box .sign-container {
    width: 150px;
    text-align: center;
    margin-bottom: 10px;
  }

  .sign-container-box .sign-container .image-1 {
    max-width: 100%;
  }

  .sign-container-box .sign-container .image-2 {
    margin-top: 10px;
    max-width: 25px;
  }

  .sign-container-box .sign-container .text {
    margin-top: 10px;
    font-size: 18px;
  }
  .sample-compare-box {
    flex-wrap: nowrap;
    margin-top: 50px;
  }

  .sample-compare-box img {
    margin: 20px;
    width: 260px;
    height: 260px;
  }

  .manage-box{
    margin-top: 20px;
  }

  .manage-box .sign-container {
    width: 300px;
    margin: 30px 30px 0;
  }

  .manage-box .sign-container:last-child {
    width: 150px;
  }

  .manage-box .image-1 {
    width: 300px;
  }

  .manage-box .image-2 {
    width: 150px;
  }

  .manage-box .sign-container .sign {
    margin-top: 20px;
    width: 100%;
  }

  .manage-box .text {
    font-size: 12px;
    text-align: justify;
    text-justify: inter-ideograph;/*IE*/
  }

  .merit-box {
    margin-top:  40px;
  }

  .merit {
    width: 160px;
  }

  .merit .image{
    width: 60px;
  }

  .merit .text-1 {
    font-size: 18px;
  }

  .merit .text-2 {
    font-size: 14px;
  }
  
  .container-5 .part-1 {
    height: 400px;
   }

  .part-2 .text {
    font-size: 22px;
  }

  .part-2 .partner-list {
    width: 600px;
    height: 100px;
  }
}

@media(max-width: 767px) {
  .container-1 {
    height: 508px;
    margin-top: 60px;
  }
  .container-2 {
    margin: 5px auto 0;
    /*height: 508px;*/
    height: auto;
  }
  .container-3 {
    height: 508px;
  }
  .container-4 {
    height: 508px;
  }
  .container-5 {
    height: 508px;
  }
  .pink-button {
    width: 220px;
    height: 45px;
    border-radius: 51px;
  }

  .white-button {
    width: 220px;
    height: 45px;
    border-radius: 51px;
  }

  .pink-button span {
    font-size: 18px;
  }

  .white-button span {
    font-size: 18px;
  }

  .cafeimage {
    height: 200px;
  }

  .container-2 .slogan {
    font-size: 18px;
    margin: 15px auto 0;
  }

  .container-3 .slogan {
    font-size: 18px;
    margin-top: 15px;
  }

  .container-4 .slogan {
    font-size: 18px;
    margin-top: 30px;
  }

  .button-1 {
    margin: 140px auto 0;
  }

  .button-2 {
    margin: 15px auto 10px;
  }

  .button-3 {
    margin: 20px auto 0;
  }

  .button-4 {
    margin: 35px auto 0;
  }

  .button-5 {
    margin: 50px auto 0;
  }

  .sign-container-box {
    display: -webkit-flex; /* Safari */
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    margin-top: 20px;
    margin-left: 30px;
    margin-right: 30px;
  }

  .sign-container-box .sign-container {
    /*width: 35%;*/
    width: 33.4%;
    text-align: center;
    margin-bottom: 10px;
  }

  .sign-container-box .sign-container .image-1 {
    max-width: 100%;
  }

  .sign-container-box .sign-container .image-2 {
    margin-top: 10px;
    max-width: 25px;
  }

  .sign-container-box .sign-container .text {
    margin-top: 10px;
    font-size: 12px;
  }
  .sample-compare-box {
    flex-wrap: wrap;
    margin-top: 20px;
  }

  .sample-compare-box img {
    margin: 10px;
    width: 165px;
    height: 165px;
  }

  .manage-box{
    margin-top: 10px;
  }

  .manage-box .sign-container {
    width: 180px;
    margin-left: 10px;
    margin-right: 10px;
  }

  .manage-box .sign-container:last-child {
    width: 100px;
  }

  .manage-box .image-1 {
    width: 180px;
  }

  .manage-box .image-2 {
    width: 100px;
  }

  .manage-box .sign-container .sign {
    margin-top: 20px;
    width: 100%;
  }

  .manage-box .text {
    font-size: 12px;
    text-align: justify;
    text-justify: inter-ideograph;/*IE*/
  }

  .merit-box {
    margin-top:  50px;
  }

  .merit {
    width: 70px;
  }

  .merit .image{
    width: 60px;
  }

  .merit .text-1 {
    font-size: 16px;
  }

  .merit .text-2 {
    font-size: 12px;
    display: none;
  }
  
  .container-5 .part-1 {
    height: 300px;
   }

  .part-2 .text {
    font-size: 18px;
    margin-top: 20px;
  }

  .part-2 .partner-list {
    margin-top: 20px;
    width: 300px;
    height: 160px;
  }

  .partner-list img {
    margin: 5px 5px 0px;
    height: 70px;
  }
}


</style>
